// test339
(339 && 0);
